'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {"drop-zone":"file-drop-zone-module_drop-zone__QKDj-"};

exports.default = styles;
//# sourceMappingURL=file-drop-zone.module.scss.js.map
